import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ShieldCheck } from "lucide-react";

export function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-slate-800 bg-[#0F172A] text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo variant="light" />
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
              PR Pathfinder provides a fast, private way to estimate your points and eligibility across
              major Canadian Provincial Nominee Program (PNP) streams. Results are informational estimates,
              not legal advice.
            </p>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-800/50 px-3 py-1.5 text-xs font-semibold text-slate-300">
              <ShieldCheck className="h-4 w-4 text-emerald-400" />
              No account required · Nothing stored on our servers
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-400">Tools</h4>
            <ul className="mt-2 space-y-0 text-sm sm:mt-4 sm:space-y-2">
              <li><Link to="/assessment" className="inline-flex min-h-[40px] items-center hover:text-white sm:min-h-0">Score Calculator</Link></li>
              <li><Link to="/results" className="inline-flex min-h-[40px] items-center hover:text-white sm:min-h-0">Eligibility Checker</Link></li>
              <li><Link to="/streams" className="inline-flex min-h-[40px] items-center hover:text-white sm:min-h-0">Stream Matrix</Link></li>
              <li><Link to="/rules" className="inline-flex min-h-[40px] items-center hover:text-white sm:min-h-0">Rules Engine</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-400">About</h4>
            <ul className="mt-2 space-y-0 text-sm sm:mt-4 sm:space-y-2">
              <li><Link to="/methodology" className="inline-flex min-h-[40px] items-center hover:text-white sm:min-h-0">Methodology</Link></li>
              <li><Link to="/privacy" className="inline-flex min-h-[40px] items-center hover:text-white sm:min-h-0">Privacy</Link></li>
              <li><Link to="/methodology#disclaimer" className="inline-flex min-h-[40px] items-center hover:text-white sm:min-h-0">Disclaimer</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-slate-800 pt-6 text-xs text-slate-500">
          © {new Date().getFullYear()} PR Pathfinder. This tool is not affiliated with the Government of
          Canada or any provincial government. Program rules change frequently — always verify with official sources.
        </div>
      </div>
    </footer>
  );
}
